import { Injectable, signal } from '@angular/core';
import { SnackbarSnackInterface } from './snackbar.interface';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  snack = signal<SnackbarSnackInterface | null>(null);

  private readonly snackStack: SnackbarSnackInterface[] = [];

  openSnack(snack: SnackbarSnackInterface | null, isMemorize?: boolean): void {
    const currentSnack = this.snack();

    if (currentSnack && isMemorize) {
      this.snackStack.push(currentSnack);
    }

    this.snack.set(snack);
  }

  closeSnack(): void {
    this.snack.set(this.snackStack.pop() ?? null);
  }
}
